export class ReloadAfterSaveError extends Error {
  constructor(public readonly originalError: unknown) {
    super('Reload after save failed');
    this.name = 'ReloadAfterSaveError';
  }
}
